import {
  useOnChange
} from "../chunk-EMWGTXSW.js";
import "../chunk-MLKGABMK.js";
export {
  useOnChange
};
